import Collapse from 'bootstrap/js/dist/collapse';

export function initAccordion() {
  document.querySelectorAll('.accordion').forEach((accordion) => {
    accordion.querySelectorAll('.accordion-item').forEach((item) => {
      const button = item.querySelector('.accordion-button');
      const collapseEl = item.querySelector('.accordion-collapse');

      if (!button || !collapseEl) return;

      const collapse = new Collapse(collapseEl, {
        toggle: false, // 👈 crucial
      });

      button.addEventListener('click', () => {
        const isOpen = collapseEl.classList.contains('show');
        
        // enlever active des autres
        accordion.querySelectorAll(".accordion-item.active").forEach((a) => {
          a.classList.remove("active");
        });
        item.classList.add("active")

        // fermer les autres items
        accordion
          .querySelectorAll('.accordion-collapse.show')
          .forEach((openEl) => {
            if (openEl !== collapseEl) {
              Collapse.getInstance(openEl)?.hide();
            }
          });

        isOpen ? collapse.hide() : collapse.show();
      });
    });
  });
}